import { Component, OnInit } from '@angular/core';
import { PreAuthenticationResponse, ReactivateAccountResponse } from '@picard/models-lib';
import { StorageConstants } from '@picard/shared-lib';
import { AuthenticationService, PreAuthenticationService, ApplicationService } from '@picard/services-lib';
import Swal from 'sweetalert2';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder } from '@angular/forms';

@Component({
    selector: 'app-activate-account',
    templateUrl: './activate-account.component.html',
    styleUrls: ['./activate-account.component.css']
  })
  export class ActivateAccountComponent implements OnInit {
    //#region Properties
    preAuthenticationResponse: PreAuthenticationResponse;
    otp: number;
    mobileNumber: string;
    programId: number;
    partnerCode: string;
    inActivation: boolean;
    @BlockUI() blockUI: NgBlockUI;
    docTheme = document.getElementById('theme-css');
    docLayout = document.getElementById('layout-css');
    //#endregion Properties

    //#region Constructor
    constructor(private _authenticationService: AuthenticationService, private _router: Router, private _activatedRoute: ActivatedRoute, private _preAuthenticationService: PreAuthenticationService, private _applicationService: ApplicationService, private _formBuilder: FormBuilder) {
        this.inActivation = false;
    }
    //#endregion Constructor

    //#region Functions
    async ngOnInit(){
        this._activatedRoute.queryParams.subscribe((params: Params) => (this.partnerCode = params['partner']));
        const hostInformation = location.hostname.split('.', 3);
        if (hostInformation[0].toLowerCase() !== 'localhost') {
        this.partnerCode = hostInformation[0];
        }
        let preAuthJson = sessionStorage.getItem(StorageConstants.preAuth);
        if (preAuthJson) {
            this.preAuthenticationResponse = JSON.parse(preAuthJson);

            if (this.docTheme) {
            this.docTheme.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.theme);
            }
            if (this.docLayout) {
            this.docLayout.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.layout);
            }

            this.programId = this.preAuthenticationResponse.programId;

            this.setBody();
        } else {
            const preAuthResponse = await this._preAuthenticationService.PreAuthenticationAsync(this.partnerCode);
            sessionStorage.setItem(StorageConstants.preAuth, JSON.stringify(preAuthResponse));
            preAuthJson = sessionStorage.getItem(StorageConstants.preAuth);
      
            if (preAuthResponse.programId === 2222) {
              const preAuthResponseBeans = await this._preAuthenticationService.PreAuthenticationAsync('scbn');
              sessionStorage.setItem('preAuthBeans', JSON.stringify(preAuthResponseBeans));
            }
      
            this.preAuthenticationResponse = JSON.parse(preAuthJson);
      
            if (this.docTheme) {
              this.docTheme.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.theme);
            }
            if (this.docLayout) {
              this.docLayout.setAttribute('href', this.preAuthenticationResponse.programmeAssetsModel.layout);
            }
      
            this.programId = this.preAuthenticationResponse.programId;
            this.setBody();
        }
    }

    async startActivation() {
        var shortcode: string = this.preAuthenticationResponse.code;
        this.blockUI.start('Trying to activate account.');
        const response = await this._authenticationService.requestAccountReactivationAsync(this.mobileNumber, shortcode);
        this.blockUI.stop();
        if (!response.isSuccessful) {
          Swal('Number entered: ' + this.mobileNumber, response.message, 'error');
          this.inActivation = false;
        } else {
          Swal('Account Found', 'An OTP has been sent via SMS to ' + this.mobileNumber, 'success');
          this.inActivation = true;
        }
    }

    async onActivation() {
        var shortcode: string = this.preAuthenticationResponse.code;
        this.blockUI.start('Activating account...');
        const reactivateAccountAsyncResponse = await this._authenticationService.reactivateAccountAsync(this.otp, this.mobileNumber, shortcode);
        this.blockUI.stop();
        this.activationSuccessMessage(reactivateAccountAsyncResponse);
      }
      activationSuccessMessage(response: ReactivateAccountResponse) {
        if (response.isSuccessful) {
          Swal({ type: 'success', title: 'Success: Your account has been activated', showConfirmButton: false, timer: 2500 });
          this._router.navigateByUrl('/login');
        } else {
          Swal({ type: 'error', title: 'Activation failed:' + response.message, showConfirmButton: false, timer: 3500 });
        }
      }
    setBody() {
        const htmlBody: HTMLLinkElement = <HTMLLinkElement>document.getElementById('picard-body');
        if (htmlBody !== null) {
          htmlBody.className = 'login-body';
          htmlBody.style.backgroundImage = `url("${this.preAuthenticationResponse.programmeAssetsModel.imageAssetsModel.bodyUrl}")`;
        }
      }
    back() {
        this._router.navigateByUrl(`/activate`);
    }
    //#endregion Functions
  }